<h2
  mat-dialog-title
  [innerHtml]="
    'USERS.BULK_IMPORT.MAP_CHANGE_DIALOG.FIELD_HAS_ALREADY_BEEN_SELECTED' | translate: { fieldName: data.fieldName }
  "
></h2>
<mat-dialog-content class="mapping-dialog">
  <p>
    <span
      [innerHtml]="
        'USERS.BULK_IMPORT.MAP_CHANGE_DIALOG.FIELD_ALREADY_SET_TO_HEADER_ROW'
          | translate: { fieldName: data.fieldName, headerRow: data.headerRow }
      "
    ></span>
    <span
      [innerHtml]="
        'USERS.BULK_IMPORT.MAP_CHANGE_DIALOG.SELECT_ANOTHER_FIELD' | translate: { fieldName: data.fieldName }
      "
    ></span>
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="cancel()">
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button mat-raised-button [mat-dialog-close]="true" color="primary">
    {{ 'COMMON.ACTION_LABELS.CONTINUE' | translate }}
  </button>
</mat-dialog-actions>
